var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("form", [
    _c("div", { staticClass: "dashboard-page-title" }, [
      _c("div", { staticClass: "container-fluid" }, [
        _c("h1", [_vm._v("Profile description")]),
        _vm._v(" "),
        _c(
          "a",
          {
            staticClass: "btn btn-info",
            on: {
              click: function ($event) {
                return _vm.$router.go(-1)
              },
            },
          },
          [_c("i", { staticClass: "fa fa-chevron-left" }), _vm._v(" Back")]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "container-fluid" }, [
      _c("div", { staticClass: "dashboard-block" }, [
        _c("div", { staticClass: "row" }, [
          _c(
            "div",
            { staticClass: "col-md-10 col-lg-8" },
            [
              _vm._m(0),
              _vm._v(" "),
              _c(
                "div",
                { attrs: { id: "redactor-intro-box" } },
                [
                  _c("redactor", {
                    attrs: { name: "description" },
                    model: {
                      value: _vm.stateDescription,
                      callback: function ($$v) {
                        _vm.stateDescription = $$v
                      },
                      expression: "stateDescription",
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "ladda-button",
                {
                  staticClass: "btn btn-primary",
                  attrs: {
                    type: "submit",
                    click: _vm.handleUpdateDescriptionCallback,
                  },
                },
                [_vm._v("\n            Save Changes\n          ")]
              ),
            ],
            1
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "alert-large alert-large-info" }, [
      _c("div", { staticClass: "icon-container" }, [
        _c("i", { staticClass: "fa fa-question" }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "alert-content" }, [
        _c("p", { staticClass: "lead m-b-none" }, [
          _vm._v("Add a description about yourself"),
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "no-margin" }, [
          _vm._v(
            "The first paragraph below will be visible without expanding to see the full content."
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }